import React from "react";
import { useNavigate } from "react-router-dom";

const EditProfileCorporate = () => {
  const navigate = useNavigate();
  return (
    <button className="dropdown-item" onClick={() => navigate("/edit-profile")}>Edit Profile</button>
  );
};

export default EditProfileCorporate; 